export const PASSENGERS = 'passengers';
export const PASSENGERS_ACTIONS = {
  PASSENGER_LOGIN: 'passenger_login',
  PASSENGER_LOGOUT: 'passenger_logout',
  PASSENGER_BOOKING_CREATE: 'passenger_booking_create',
  PASSENGER_BOOKING_GET: 'passenger_booking_get',
  PASSENGER_BOOKING_CANCEL: 'passenger_booking_cancel',
  PASSENGER_DELETE: 'passenger_delete',
  PASSENGER_BOOKING_NEW: 'passenger_booking_new',
  PASSENGER_BOOKING_STATE_CHANGE: 'passenger_booking_state_change',
  PASSENGER_BOOKING_DELETE: 'passenger_booking_delete',
};

export const DRIVERS = 'drivers';
export const DRIVERS_ACTIONS = {
  DRIVER_LOGIN: 'driver_login',
  DRIVER_LOGOUT: 'driver_logout',
  DRIVER_DELETE: 'driver_delete',
  DRIVER_SET_AVAILABILITY: 'driver_set_availability',
  DRIVER_SET_AUTO_ACCEPT: 'driver_set_auto_accept',
  DRIVER_SET_LOCATION: 'driver_set_location',
  DRIVER_BOOKING_BID: 'driver_booking_bid',
  DRIVER_BOOKING_CANCEL: 'driver_booking_cancel',
  DRIVER_BOOKING_PICK_UP: 'driver_booking_pick_up',
  DRIVER_BOOKING_DROP_OFF: 'driver_booking_drop_off',
  DRIVER_BOOKING_NEW: 'driver_booking_new',
  DRIVER_BOOKING_STATE_CHANGE: 'driver_booking_state_change',
  DRIVER_BOOKING_DELETE: 'driver_booking_delete',
};

export const COHORTS = 'cohorts';
export const COHORTS_ACTIONS = {
  COHORT_CREATE: 'cohort_create',
  COHORT_GET: 'cohort_get',
  COHORT_DELETE: 'cohort_delete',
  UNSET_COHORT: 'unset_cohort',
  COHORT_PASSENGER_ASSOCIATE: 'cohort_passenger_associate',
  COHORT_PASSENGER_UPDATE: 'cohort_passenger_update',
  COHORT_DRIVER_ASSOCIATE_INSTANT: 'cohort_driver_associate_instant',
  COHORT_DRIVER_ASSOCIATE: 'cohort_driver_associate',
  COHORT_DRIVER_UPDATE: 'cohort_driver_update',
  COHORT_MERCHANT_ASSOCIATE: 'cohort_merchant_associate',
  COHORT_MERCHANT_UPDATE: 'cohort_merchant_update',
};

export const MERCHANTS = 'merchants';
export const MERCHANTS_ACTIONS = {
  MERCHANT_DELETE: 'merchant_delete',
};



/** WEBPACK FOOTER **
 ** ./src/js/utils/ga-utils.js
 **/